import React from 'react';
import {Form, InputNumber} from 'antd';

import {EditableContext} from "../../context/EditableTable";

import {roundNumberUpToPrecision} from "../../helpers/misc";
import './style.less';

export default class EditableCell extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            editing: false,
        }
    }

    toggleEdit = () => {
        const editing = !this.state.editing;
        this.setState({editing}, () => {
            if (editing) {
                this.input.focus();
            }
        });
    };

    // Save field value as new booking data entry
    save = async (field) => {
        const form = this.context;
        const {record, handleSave} = this.props;

        try {
            const values = await form.validateFields();
            const newData = {...record, [field]: values[field]};

            const calculatedData = this.calculate(newData, record, field);

            handleSave(calculatedData);

            this.toggleEdit();
        } catch (error) {

        }
    };

    calculate = (data, oldData, field) => {
        const {kmStart, kmEnd, distance} = data;
        const oldDistance = oldData.distance;

        const precisionDigits = 4;

        // when directly enter distance, null-ify kmStart and kmEnd
        if (field === 'distance' && distance !== oldDistance) {
            data.kmStart = null;
            data.kmEnd = null;

            //Enforce distance to 0 when existing distance is manually removed
            if (distance === null && oldDistance !== null) {
                data.distance = 0;
            } else {
                data.distance = roundNumberUpToPrecision(distance, 4);
            }
        } else if ( // if kmStart and kmEnd both exist, calculate distance
            field !== 'distance' &&
            kmStart !== null && kmStart !== undefined &&
            kmEnd !== null && kmEnd !== undefined
        ) {
            let newDistance = (kmEnd - kmStart).toFixed(precisionDigits);

            data.distance = Math.max(newDistance, 0);
        }

        return data;
    };

    renderCell = ({dataIndex, record, displayName, children}) => {
        const {editing} = this.state;
        let component;

        if (editing === true) { //when editing, display form item
            component = <Form.Item
                name={[dataIndex]}
                className="input-form-entry"
                initialValue={record[dataIndex]}
                rules={[{type: 'number', message: `${displayName} is not a number`}]}
            >
                <InputNumber
                    type="number"
                    step='any'
                    min={0}
                    ref={node => (this.input = node)}
                    onPressEnter={() => this.save(dataIndex)}
                    onBlur={() => this.save(dataIndex)}
                    className="input-cell"
                />
            </Form.Item>
        } else {    // when not editing, display div
            component = <div
                className="editable-cell-value-wrap"
                onClick={() => this.toggleEdit(record)}
            >
                {children}
            </div>
        }

        return component;
    };

    render() {
        const {editable, children} = this.props;

        return <td>
            {editable ? (
                this.renderCell(this.props)
            ) : (
                children
            )}
        </td>
    }
}

EditableCell.contextType = EditableContext;
